<template>
  <div>
    <topbar
      :titulo="$t('CONTABIL.LANCAMENTOS_CONTABEIS')"
      :subtitulo="titulo"
      :breadcrumbs="breadcrumbs"
    />

    <div class="container-fluid mt-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3>{{ titulo }}</h3>
        <div>
          <b-button variant="secondary" @click="voltar">{{ $t('GERAL.VOLTAR') }}</b-button>
          <b-button variant="primary" class="ml-2" @click="salvar">{{ $t('GERAL.SALVAR') }}</b-button>
        </div>
      </div>

      <div class="mb-4">
        <dados-documento
          :form="formulario"
          :valor="maiorSoma"
          @refs="capturarRefs"
        />
      </div>

      <div>
        <h4>{{ $t('CONTABIL.LISTA_LANCAMENTOS_VINCULADOS') }}</h4>
        <dados-documento-item
          ref="documentoItem"
          :form="formularioDocumentoItem"
          :resetarValidacao="resetarValidacao"
          @adicionarDocumentoItem="adicionarDocumentoItem"
        />
        <tabela-documento
          ref="tabelaDocumento"
          :items="formulario.itens"
          :keyAtualizatabela="keyAtualizatabela"
          @removerDocumentoItem="removerDocumentoItem"
          @editarDocumentoItem="abrirModalEditarItem"
        />
        <b-row class="mt-3">
          <b-col>
            <b><h5>Total Crédito: {{ formatarValor(creditoTotal) }}</h5></b>
          </b-col>
          <b-col>
            <b><h5>Total Débito: {{ formatarValor(debitoTotal) }}</h5></b>
          </b-col>
        </b-row>
      </div>
    </div>
    <modal-editar-documento-item
      v-show="itemSelecionado"
      ref="modalEditarDocumentoItem"
      :item="itemSelecionado"
      @atualizar-item="atualizarItemNaTabela"
    />
  </div>
</template>

<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import DadosDocumento from './components/modal/Dados.vue';
import TabelaDocumento from './components/modal/Tabela.vue';
import DadosDocumentoItem from './components/modal/DadosDocumentoItem.vue';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import LancamentoContabilService from '@/common/services/lancamento-contabil/lancamento-contabil.service.js';
import ModalEditarDocumentoItem from './components/modal/ModalEditarDocumentoItem.vue';
import confirmarDiferencaDebitoCredito from './confirmarDiferencaDebitoCredito';
export default {
  name: 'LancamentosContabeisForm',
  components: {
    Topbar,
    DadosDocumento,
    TabelaDocumento,
    DadosDocumentoItem,
    ModalEditarDocumentoItem,
  },
  data() {
    return {
      keyAtualizatabela: 1,
      resetarValidacao: false,
      formulario: { itens: [] },
      formularioDocumentoItem: {},
      itemSelecionado: null,
      refs: [],
      edicao: false,
      breadcrumbs: [
        { titulo: this.$t('CONTABIL.CONTABIL') },
        { titulo: this.$t('CONTABIL.LANCAMENTOS_CONTABEIS') },
        { titulo: this.$t('GERAL.EDITAR') },
      ],
    };
  },
  computed: {
    titulo() {
      return this.formulario.id
        ? this.$t('GERAL.EDITAR')
        : this.$t('GERAL.CADASTRAR');
    },
    maiorSoma() {
      let creditoTotal = 0;
      let debitoTotal = 0;
      this.formulario.itens.forEach((movimento) => {
        if (movimento.tipoMovimentoDescricao === 'Crédito') {
          creditoTotal += movimento.valor;
        } else if (movimento.tipoMovimentoDescricao === 'Débito') {
          debitoTotal += movimento.valor;
        }
      });
      return Math.max(creditoTotal, debitoTotal);
    },
    creditoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        return item.tipoMovimentoDescricao === 'Crédito'
          ? total + item.valor
          : total;
      }, 0);
    },
    debitoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        return item.tipoMovimentoDescricao === 'Débito'
          ? total + item.valor
          : total;
      }, 0);
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.carregarLancamento(this.$route.params.id);
    }
  },
  methods: {
    voltar() {
      this.$router.push('/contabil/lancamentos');
    },
    carregarLancamento(id) {
      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.carregarInformacoesPorId(id)
        .then((res) => {
          this.formulario = res;
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    formatarValor(valor) {
      return valor ? helpers.formatacaoMoedaBRL(valor) : '';
    },
    capturarRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    abrirModalEditarItem(item) {
      this.itemSelecionado = item;
      this.$nextTick(() => {
        if (this.$refs.modalEditarDocumentoItem) {
          this.$refs.modalEditarDocumentoItem.abrir();
        } 
      });
    },
    atualizarItemNaTabela(itemAtualizado) {
      const index = this.formulario.itens.findIndex(item => item === this.itemSelecionado);
      if (index !== -1) {
        const itemCorrigido = {
          ...this.formulario.itens[index],
          ...itemAtualizado,
          valor: Number(itemAtualizado.valor),
        };
        this.$set(this.formulario.itens, index, itemCorrigido);
        this.keyAtualizatabela++;
        this.itemSelecionado = null;
      }
    },
    async salvar() {
      if (!this.validarFormulario()) return;
      if (!(await confirmarDiferencaDebitoCredito(this.debitoTotal, this.creditoTotal))) return;
      const dados = {
        ...this.formulario,
        categoria: this.formulario.categoriaId,
        documentoContabeisItens: this.formulario.itens,
      };
      if (this.formulario.id) {
        this.atualizar(dados);
      } else {
        this.criar(dados);
      }
    },
    criar(dados) {
      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.criar(dados)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.voltar();
        })
        .catch((err) => mensagem.showErrors(err))
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    atualizar(dados) {
      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.atualizar(dados)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
        })
        .catch((err) => mensagem.showErrors(err))
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    adicionarDocumentoItem() {
      this.edicao = false;
      if (
        !this.formularioDocumentoItem?.id &&
        (this.formularioDocumentoItem?.index || this.formularioDocumentoItem?.index === 0)
      ) {
        this.formulario.itens[this.formularioDocumentoItem.index] = {
          ...this.formularioDocumentoItem,
        };
        this.keyAtualizatabela++;
        return this.limparFormularioDocumentoItem();
      }
      this.adicionarDocumentoItemLocal();
      this.limparValidacaoFormItem();
    },
    limparValidacaoFormItem() {
      setTimeout(() => {
        this.resetarValidacao = true;
      }, 50);
      this.resetarValidacao = false;
    },
    adicionarDocumentoItemLocal() {
      const itemLancamento = {
        tipoMovimentoDescricao: this.formularioDocumentoItem.tipoMovimento.descricao,
        tipoMovimento: this.formularioDocumentoItem.tipoMovimento.id,
        valor: this.formularioDocumentoItem.valor,
        planoContaId: this.formularioDocumentoItem.planoConta.id,
        descricao: this.formularioDocumentoItem.descricao,
        contaContabilCompleto: `${this.formularioDocumentoItem.planoConta.codigo} - ${this.formularioDocumentoItem.planoConta.descricao}`,
      };
      if (!this.formulario?.itens) this.formulario = { ...this.formulario, itens: [] };
      this.formulario.itens.push(itemLancamento);
      setTimeout(() => this.limparFormularioDocumentoItem(), 100);
    },
    limparFormularioDocumentoItem() {
      this.formularioDocumentoItem = {
        descricao: '',
        planoConta: '',
        valor: null,
        tipoMovimento: '',
      };
      this.limparValidacaoFormItem();
    },
    removerDocumentoItem(item) {
      this.confirmarExclusao(item);
    },
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM'),
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM_MENSAGEM')
      );
      if (respostaExclusao.value) {
        this.formulario.itens.splice(item.index, 1);
      }
    },
  },
  watch: {
    maiorSoma(valor) {
      this.formulario.valor = valor;
    },
  },
};
</script>
